import { defineStore } from 'pinia'
import {
  fetchItems,
  fetchItem,
  createItem,
  updateItem,
  destroyItem,
  archiveItem
} from '@/apps/traforama/api/campaigns'
import {
  ICampaignsFilter,
  ICampaignsPayload
} from '@/apps/traforama/interfaces/campaigns'

import useCrudStore from '@/hooks/useCrudStore'
import { useCreativesStore } from './creatives'

export const useCampaignsStore = defineStore('campaigns', () => {
  const creativesStore = useCreativesStore()
  const defaultFilter: ICampaignsFilter = {
    disabled: false,
    state: ['review', 'new', 'approved', 'paused']
  }

  const {
    currentItems,
    total,
    filter,
    closed,
    selected,
    items,
    listLoading,
    itemsLoading,
    currentPage,
    FetchItem,
    SaveItem,
    DestroyItem,
    SetCurrentPage,
    ToggleClose,
    SetFilters,
    error,
    itemById,
    payload,
    setItems,
    setCurrentItems,
    setTotal,
    removeItem
  } = useCrudStore({
    defaultFilter,
    fetchItem,
    createItem,
    updateItem,
    destroyItem
  })

  const FetchItems = async (
    currentPayload: undefined | ICampaignsPayload = undefined
  ) => {
    currentPayload = currentPayload || payload.value
    listLoading.value = true
    try {
      const response = await fetchItems(currentPayload)
      setItems(response.data)
      setCurrentItems(response.data)
      setTotal(response.meta.total)
      creativesStore.SetItems(response.included)
    } catch (e: any) {
      error.value = e.toString()
    } finally {
      listLoading.value = false
      error.value = null
    }
  }

  const ArchiveCampaign = async (id: string) => {
    await archiveItem(id)
    removeItem(id)
  }

  return {
    currentItems,
    items,
    total,
    listLoading,
    itemsLoading,
    FetchItems,
    FetchItem,
    SaveItem,
    DestroyItem,
    SetCurrentPage,
    ToggleClose,
    SetFilters,
    ArchiveCampaign,
    selected,
    closed,
    filter,
    defaultFilter,
    currentPage,
    itemById
  }
})
